var E = require('./index.js');
module.exports = new E();



//////////////////
// WEBPACK FOOTER
// ./~/tiny-emitter/instance.js
// module id = 339
// module chunks = 1